import React from "react"
import { AttendanceDonut, AvailabilityDonut, BookingsByDateLineGraph } from "@components"
import PropTypes from "prop-types"

const SessionStats = ({ bookingCountsByDate = [], stats }) => {
  const totalAttendanceSlots = stats.absent + stats.attended + stats.unknown

  return (
    <div>
      <div id="attendance">
        <h2 className="mb-1 text-lg font-semibold text-foreground">Attendance Stats</h2>
        
        {stats.booked === 0 && (
          <p className="text-sm text-content2-foreground">Attendance stats will be displayed here when bookings have been made.</p>
        )}

        {stats.booked > 0 && (
          <React.Fragment>
            <p className="mb-2 text-sm text-content2-foreground">Of those that booked who attended.</p>
            
            <AttendanceDonut
              height={300}
              noOfAbsentSlots={stats.absent}
              noOfAttendedSlots={stats.attended}
              noOfUnknownSlots={totalAttendanceSlots === 0 ? stats.booked : stats.unknown}
              noOfTotalSlots={stats.booked}
            />
          </React.Fragment>
        )}
      </div>

      <div className="my-5 border-t border-gray-500 border-dotted" />
      
      <div id="availability">
        <h2 className="mb-1 text-lg font-semibold text-foreground">Availability Stats</h2>
        <p className="mb-2 text-sm text-content2-foreground">Breakdown of your slots.</p>

        <AvailabilityDonut
          height={300}
          noOfAvailableSlots={stats.available}
          noOfBookedSlots={stats.booked}
          noOfDisabledSlots={stats.disabled}
          noOfTotalSlots={stats.total}
        />
      </div>

      <div className="my-5 border-t border-gray-500 border-dotted" />

      <div id="bookings">
        <h2 className="mb-1 text-lg font-semibold text-foreground">Booking Stats</h2>
        {stats.booked === 0 && (
          <p className="text-sm text-content2-foreground">Booking stats will be displayed here when bookings have been made.</p>
        )}

        {stats.booked > 0 && (
          <React.Fragment>
            <p className="mb-2 text-sm text-content2-foreground">Bookings by date.</p>
            <BookingsByDateLineGraph data={bookingCountsByDate} />
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

SessionStats.propTypes = {
  stats: PropTypes.shape({
    absent: PropTypes.number.isRequired,
    attended: PropTypes.number.isRequired,
    unknown: PropTypes.number.isRequired,
    booked: PropTypes.number.isRequired,
    available: PropTypes.number.isRequired,
    disabled: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  }).isRequired,

  bookingCountsByDate: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      count: PropTypes.number,
    })
  ),
}

export default SessionStats
